<template>
  <div>
    <el-form :inline="true" :model="stationSearchForm" class="user-search" size="mini">
      <el-select v-model="value" size="mini" placeholder="请选择" @change="selectLevel">
        <el-option
          v-for="item in options"
          :disabled="!checkPermission([item.excelPermission,item.reportPermission])"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      <!--<el-form-item label="" prop="selectedOperator">
        <el-select clearable v-model="stationSearchForm.selectedOperator" placeholder="选择运营商" @change="operatorSelect">
          <el-option
            v-for="item in operators"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>-->
      <el-cascader ref="cascader" clearable :model="stationSearchForm" placeholder="选择运营商"
                   size="mini" :show-all-levels="false" filterable
                   :options="operatorsTree" v-model="operatorIds"
                   :props="{ checkStrictly: true,expandTrigger: 'hover'}" @change="handChangeOperator"></el-cascader>
      <el-form-item label="" prop="stationCode">
        <el-select size="mini"
                   clearable
                   filterable
                   v-model="stationSearchForm.stationCode"
                   placeholder="站点">
          <el-option v-for="item in stations"
                     :key="item.id"
                     :label="item.stationName"
                     :value="item.stationCode">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="省市区" prop="operator.province">
        <el-cascader
          placeholder="请选择或搜索省/市/区"
          filterable
          clearable
          change-on-select
          @change="handleChangeProvince"
          :options="areas"
          :props="{value:'name',label:'name',children:'children'}"
        ></el-cascader>
      </el-form-item>
      <el-form-item label="">
        <el-date-picker v-model="stationSearchForm.beginTime"
                        clearable
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="开始时间"
                        v-if="showDay"
                        style="width: 125px">
        </el-date-picker>
        <el-date-picker v-model="stationSearchForm.endTime"
                        clearable
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="结束时间"
                        v-if="showDay"
                        style="width: 125px">
        </el-date-picker>
        <el-date-picker v-model="stationSearchForm.beginTime"
                        clearable
                        type="month"
                        value-format="yyyy-MM"
                        placeholder="开始时间"
                        v-if="showMonth"
                        style="width: 125px">
        </el-date-picker>
        <el-date-picker v-model="stationSearchForm.endTime"
                        clearable
                        type="month"
                        value-format="yyyy-MM"
                        placeholder="结束时间"
                        v-if="showMonth"
                        style="width: 125px">
        </el-date-picker>
        <el-date-picker v-model="stationSearchForm.beginTime"
                        clearable
                        type="year"
                        value-format="yyyy"
                        placeholder="开始时间"
                        v-if="showYear"
                        style="width: 125px">
        </el-date-picker>
        <el-date-picker v-model="stationSearchForm.endTime"
                        clearable
                        type="year"
                        value-format="yyyy"
                        placeholder="结束时间"
                        v-if="showYear"
                        style="width: 125px">
        </el-date-picker></el-form-item>
      <el-form-item>
        <el-button size="mini" type="primary" @click="resetSearchForm">清空</el-button>
        <el-button
                   type="primary" icon="el-icon-search" @click="searchStationReport">查询</el-button>
        <el-button v-if="checkPermission(['bee:order:chargingRequest:excel'])"
                   type="primary" icon="el-icon-download" @click="exportData">Excel导出</el-button>
      </el-form-item>
    </el-form>
    <el-table v-loading="loading" element-loading-text="拼命加载中" :data="stationOrder" highlight-current-row border style="width: 100%;">
      <af-table-column prop="operatorId" label="运营商" width="250px">
      </af-table-column>
      <af-table-column prop="stationId" label="场站">
      </af-table-column>
      <af-table-column prop="province" label="省">
      </af-table-column>
      <af-table-column prop="city" label="市">
      </af-table-column>
      <af-table-column prop="area" label="区">
      </af-table-column>
      <af-table-column prop="day" label="日期" v-if="showDay">
      </af-table-column>
      <af-table-column prop="month" label="月份" v-if="showMonth">
      </af-table-column>
      <af-table-column prop="year" label="年份" v-if="showYear">
      </af-table-column>
      <af-table-column prop="totalElectricity" :formatter="formatElectricity" label="充电量(kW·h)">
      </af-table-column>
      <af-table-column prop="totalFee" label="充电收入(元)">
      </af-table-column>
      <af-table-column prop="totalElectricityFee" :formatter="formatElectricitys" label="电费(元)">
      </af-table-column>
      <af-table-column prop="serviceFee" :formatter="formatElectricitys" label="服务费(元)">
      </af-table-column>
      <af-table-column prop="orderNum" label="服务次数(次)">
      </af-table-column>
    </el-table>
    <Pagination v-bind:child-msg="pageparam" @callFather="getStationReport"></Pagination>
  </div>
</template>

<script>
  import Pagination from '@/module/cardManage/component/Pagination.vue'
  import api from '@/module/dataCenter/api/report.js'
  import commonApi from '@/common/api/commonFromVuexApi.js'
  import report from '@/module/dataCenter/api/report.js'
  import comApi from '@/common/api/commonApi.js'


  export default {
    name: 'list',
    data() {
      return {
        operatorsTree: [],
        operatorIds: [],
        stationOrder:[],
        stationSearchForm:{},
        selectedOperator: '',
        stations: '',
        selectedStation: '',
        operators: '',
        loading: false,
        showDay: true,
        showMonth: false,
        showYear: false,
        areas: [],
        options: [{
          value: '1',
          label: '每天订单',
          reportPermission: 'bee:order:report:stationDailyReport',
          excelPermission: 'bee:order:report:excel:stationDailyOrder'
        }, {
          value: '2',
          label: '每月订单',
          reportPermission: 'bee:order:report:stationMonthlyReport',
          excelPermission: 'bee:order:report:excel:stationMonthlyOrder'
        }, {
          value: '3',
          label: '每年订单',
          reportPermission: 'bee:order:report:stationYearlyReport',
          excelPermission: 'bee:order:report:excel:stationYearlyOrder'
        }],
        value: '1',//下拉选择框选中值
        pageparam: {
          t: {},
          currentPage: 1,
          pageSize: 10,
          total: 0
        },
      }
    },
    components: {
      Pagination
    },
    created() {
      this.loadOperators()
      // this.getStations()
      this.getOperatorsTree()
      this.searchStationReport()
    },
    mounted() {
      this.getArea()
    },
    computed: {
      reportPermissions: {
        get() {
          const perms = []
          this.options.forEach(item => perms.push(item.reportPermission))
          return perms
        }
      },
      excelPermissions: {
        get() {
          const perms = []
          this.options.forEach(item => perms.push(item.excelPermissions))
          return perms
        }
      }
    },
    methods: {
      getOperatorsTree(){
        let params = JSON.stringify({})
        comApi.getOperatorsTree(params).then((res) => {
          this.operatorsTree = res.data
        })
      },
      handChangeOperator(value){
        let operatorId = value && value.length>0 ? value[value.length - 1] : ''
        this.selectedOperator = operatorId
        report.stationList([operatorId]).then((res)=>{
          this.stations = res.data
        })
        this.$refs.cascader.dropDownVisible = false
      },
      //加载运营商列表
      loadOperators() {
        commonApi.getOperators().then((res) => {
          this.operators = res
        })
      },
      // 站点
      // getStations() {
      //   commonApi.getStations().then((res) => {
      //     this.stations = res
      //   })
      // },
      // 站点
      operatorSelect() {
        report.stationList([this.selectedOperator]).then((res)=>{
          this.stations = res.data
        })
      },
      resetSearchForm() {
        this.stationSearchForm = {}
        this.value = '1'
        this.selectedOperator = ''
        this.operatorIds = []
        this.searchStationReport()
      },
      formatElectricity:function(row,column){
        let electricity = row[column.property]
        if(!electricity){
          return 0;
        }
        return Number(electricity).toFixed(2);
      },
      formatElectricitys:function(row,column){
        let electricity = row[column.property]
        if(!electricity){
          return 0;
        }
        return Number(electricity).toFixed(2);
      },
      searchStationReport(){
        this.getStationReport()
      },
      getStationReport(){
        this.pageparam.t = {
          opeartorId: this.selectedOperator,
          stationCode: this.stationSearchForm.stationCode,
          province: this.stationSearchForm.province,
          city: this.stationSearchForm.city,
          area: this.stationSearchForm.area,
          beginTime: this.stationSearchForm.beginTime===undefined?'':this.stationSearchForm.beginTime,
          endTime: this.stationSearchForm.endTime===undefined?'':this.stationSearchForm.endTime
        }
        let param = Object.assign({}, this.pageparam)
        switch(this.value){
          case '1':{
            this.stationDailyOrder(param)
            break;
          }
          case '2':{
            this.stationMonthlyOrder(param)
            break;
          }
          case '3':{
            this.stationYearlyOrder(param)
            break;
          }
        }
      },
      //依据选择的维度（日/月/年）获取表格数据
      selectLevel(){
        //位于站报表tab页
        this.stationSearchForm.beginTime = ''
        this.stationSearchForm.endTime = ''
        switch(this.value){
          case '1':{
            this.showDay = true
            this.showMonth = false
            this.showYear = false
            this.stationDailyOrder()
            break;
          }
          case '2':{
            this.showDay = false
            this.showMonth = true
            this.showYear = false
            this.stationMonthlyOrder()
            break;
          }
          case '3':{
            this.showDay = false
            this.showMonth = false
            this.showYear = true
            this.stationYearlyOrder()
            break;
          }
        }
      },
      stationDailyOrder(param){
        this.loading = true;
        api.getStationDailyReport(param).then((res)=>{
          if (res.code === 0) {
            this.pageparam.total = res.data.total
            this.stationOrder = res.data.list
            this.loading = false;
          } else {
            this.$message.error(res.message);
          }
        })
      },
      stationMonthlyOrder(param){
        this.loading = true;
        api.getStationMonthlyReport(param).then((res)=>{
          if (res.code === 0) {
            this.pageparam.total = res.data.total
            this.stationOrder = res.data.list
            this.loading = false;
          } else {
            this.$message.error(res.message);
          }
        })
      },
      stationYearlyOrder(param){
        this.loading = true;
        api.getStationYearlyReport(param).then((res)=>{
          if (res.code === 0) {
            this.pageparam.total = res.data.total
            this.stationOrder = res.data.list
            this.loading = false;
          } else {
            this.$message.error(res.message);
          }
        })
      },
      async exportData(){
        this.pageparam.t = {
          opeartorId: this.selectedOperator,
          stationCode: this.stationSearchForm.stationCode,
          beginTime: this.stationSearchForm.beginTime===undefined?'':this.stationSearchForm.beginTime,
          endTime: this.stationSearchForm.endTime===undefined?'':this.stationSearchForm.endTime
        }
        //场站报表导出
        switch(this.value) {
          case '1' : {
            let flag = false
            if (this.pageparam.t.beginTime == null || this.pageparam.t.endTime == null || this.pageparam.t.beginTime == '' || this.pageparam.t.endTime == '') {
              flag = false
            } else {
              let beginDate = new Date(this.pageparam.t.beginTime.substring(0,10))
              let endDate = new Date(this.pageparam.t.endTime.substring(0,10))
              let diffYear = endDate.getFullYear()-beginDate.getFullYear()
              let diffMonth = diffYear*12 + endDate.getMonth()-beginDate.getMonth()
              let diffDay = endDate.getDate()-beginDate.getDate()
              if (diffMonth<3 || (diffMonth == 3 && diffDay <=0 )) {
                flag = true
              }
            }
            if (flag) {
              api.downloadStation(this.pageparam.t).then((res)=>{
                if (res){
                  this.downloadExcel(res,'场站每天订单汇总')
                }
              })
            } else {
              this.$message.error('请选择三个月之内数据导出')
            }
            break;
          }
          case '2' : {
            api.downloadStation2(this.pageparam.t).then((res)=>{
              if (res){
                this.downloadExcel(res,'场站每月订单汇总')
              }
            })
            break;
          }
          case '3' : {
            api.downloadStation3(this.pageparam.t).then((res)=>{
              if (res){
                this.downloadExcel(res,'场站每年订单汇总')
              }
            })
            break;
          }
        }
      },

      //下载excel,res为要导出的内容，name为文件名
      downloadExcel(res,name) {
        const blob = new Blob([res],{
          type: 'application/vnd.ms-excel;charset=utf-8'
        })
        const downloadElement = document.createElement('a')
        const href = window.URL.createObjectURL(blob)
        downloadElement.href = href
        downloadElement.download = name+'.xlsx'
        document.body.appendChild(downloadElement)
        downloadElement.click()
        document.body.removeChild(downloadElement) // 下载完成移除元素
        window.URL.revokeObjectURL(href) // 释放掉blob对象
      },
      // 三级联动事件
      handleChangeProvince(value) {
        this.stationSearchForm.province = value[0]
        this.stationSearchForm.city = value[1]
        this.stationSearchForm.area = value[2]
      },
      getArea() {
        commonApi.getAllAreas().then((res) => {
          this.areas = res
        })
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/module/dataCenter/page/baobiao/station/list.vue